export default {
  wifis: [],
  pagination: {},
  wifi: {}
}
